import React, { ReactNode } from 'react';
import { InfoIcon } from 'lucide-react';
import type { LegalSection } from '../../types/content';
import { legalReviewNote } from '../../data/legal';
interface LegalDocumentProps {
  sections: LegalSection[];
  showReviewNote?: boolean;
  children?: ReactNode;
}
export function LegalDocument({
  sections,
  showReviewNote = true,
  children
}: LegalDocumentProps) {
  const slug = (heading: string) => heading.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  return <section className="bg-porcelain" data-id="element-423" data-mp="1q8lfia9s3f2t">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 lg:grid-cols-12 lg:px-10 lg:py-24" data-id="element-424" data-mp="1q7jx1kqfnqb2">
        <nav aria-label="On this page" className="lg:col-span-3" data-id="element-425" data-mp="1cgf2gx1x9o7l">
          <div className="lg:sticky lg:top-28" data-id="element-426" data-mp="1gijqng9lpsmu">
            <p className="text-sm font-semibold text-aubergine" data-id="element-427" data-mp="1gh8n9hk2imw9">On this page</p>
            <ul className="mt-4 space-y-2.5 border-l border-plum/10" data-id="element-428" data-mp="247bczr0ifgrp">
              {sections.map(s => <li key={s.heading} data-id="element-429" data-mp="290nr377kc567">
                  <a href={`#${slug(s.heading)}`} className="-ml-px block border-l border-transparent pl-4 text-sm text-plum/65 hover:border-copper hover:text-plum" data-id="element-430" data-mp="290xfwrgvg6ab">
                    {s.heading}
                  </a>
                </li>)}
            </ul>
          </div>
        </nav>
        <div className="lg:col-span-8 lg:col-start-5" data-id="element-431" data-mp="3hwwlekwkvvla">
          {showReviewNote && <div className="mb-12 flex gap-3 rounded-xl bg-limestone p-5 text-sm leading-relaxed text-plum/80" data-id="element-432" data-mp="3hv3ct02en1an">
              <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-copper-deep" aria-hidden="true" data-id="element-433" data-mp="3rmpv1gd5u0mw" />
              <p data-id="element-434" data-mp="9h33c1mlmc24">{legalReviewNote}</p>
            </div>}
          <div className="space-y-12" data-id="element-435" data-mp="9gbk7qa6u6sq">
            {sections.map(s => <section key={s.heading} id={slug(s.heading)} aria-labelledby={`${slug(s.heading)}-h`} data-id="element-436" data-mp="4j1j3ddfs6p2">
                <h2 id={`${slug(s.heading)}-h`} className="text-2xl font-semibold text-aubergine" data-id="element-437" data-mp="2b9958zxq3v34">
                  {s.heading}
                </h2>
                <div className="mt-4 space-y-4" data-id="element-438" data-mp="a68c5rpe1zgp">
                  {s.paragraphs.map(p => <p key={p} className="max-w-prose leading-relaxed text-plum/75" data-id="element-439" data-mp="f5bh7c5dc5oo">
                      {p}
                    </p>)}
                </div>
              </section>)}
          </div>
          {children}
        </div>
      </div>
    </section>;
}